import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import CommonStrings from 'resources/common-strings';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import HelpBox from 'components/generic/help/index';

export default CreateReactClass({
    displayName: 'highlights-data',

    propTypes: {
        highlights: PropTypes.instanceOf(Immutable.List),
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
    },

    getInitialState() {
        return {
            showAllHighlights: false,
            showHighlightText: CommonStrings.highlights.showMore,
            expandingCollapsing: false,
        };
    },

    helpText() {
        return (
            <div key="highlights-help-content">
                <p key="initial-text"> {CommonStrings.highlights.helpInitialText} </p>
                <div key="highlights-help-link">
                    <strong key="help-read-more">{CommonStrings.highlights.readMoreText}</strong>
                    <a key="help-link" href={CommonStrings.highlights.helpLink} target="_blank">
                        {' '}
                        {CommonStrings.highlights.helpText}{' '}
                    </a>
                </div>
            </div>
        );
    },

    render() {
console.log("this.props.highlights ::"+JSON.stringify(this.props.highlights))

        if (!this.props.highlights || this.props.highlights.size == 0) {
            return null;
        } else {
            let highlightRowClass = 'highlight halfWidth';
            if (this.props.highlights.size == 1) {
                highlightRowClass = 'highlight fullWidth';
            }
            const highlightRows = this.props.highlights
                .filter((h) => {
                    const hasNecessaryFields = !!h.get('message') && !!h.get('iconUri');
                    if (!hasNecessaryFields) {
                        Analytics.logErrorToDatadog(`unexpected highlight: ${h} in ${this.props.highlights}`);
                    }
                    return hasNecessaryFields;
                })
                .map((data) => {
                    const message = { __html: data.get('message') };

                    return (
                        <div key={data.get('priority')} className={highlightRowClass}>
                            <img src={data.get('iconUri')} key="highlightIcon" className="highlight-icon" />
                            <p key="start" dangerouslySetInnerHTML={message} />
                        </div>
                    );
                });

            const showMoreArea = highlightRows.size > 4 ? 'show-more-area' : 'hide';
            const toggleHighlightsVisibility = (event) => {
                Analytics.recordButtonClick(
                    CommonValues.SectionIDs.highlights,
                    'show-more',
                    this.state.showAllHighlights ? 'hide' : 'show'
                );
                this.setState({
                    showAllHighlights: !this.state.showAllHighlights,
                    showHighlightText: this.state.showAllHighlights
                        ? CommonStrings.highlights.showMore
                        : CommonStrings.highlights.showLess,
                    expandingCollapsing: true,
                });
                setTimeout(() => this.setState({ expandingCollapsing: false }), 1500);
            };
            const showMoreHighlights =
                highlightRows.size > 4 ? (
                    <div
                        key={`show-more-${this.props.subject.get('shortName')}`}
                        className={showMoreArea}
                        onClick={toggleHighlightsVisibility}
                    >
                        <span className="triangle">&#9654;</span>
                        <span
                            key={`show-more-text-${this.props.subject.get('shortName')}`}
                            className={this.state.showMoreTextClass}
                        >
                            {this.state.showHighlightText}
                        </span>
                    </div>
                ) : null;
            const expandCollapseClass = this.state.expandingCollapsing ? 'expanding' : '';
            const rowClass = this.state.showAllHighlights ? (highlightRows.size > 4 ? 'expanded' : '') : 'reduced';
            const classes = `highlights-data ${this.props.subject.get('shortName')} ${expandCollapseClass} ${rowClass}`;

            return (
                <div key={`highlights-data-${this.props.subject.get('shortName')}`} className={classes}>
                    <span className="help-message">
                        <HelpBox
                            id={'highlights-help-box'}
                            helpContentsRenderer={this.helpText}
                            moduleName={CommonValues.SectionIDs.highlights}
                            appLevelCssClassName="highlight-help-box"
                            helpLabel="highlights-default-help"
                        />
                    </span>
                    {highlightRows}
                    {showMoreHighlights}
                </div>
            );
        } // if (this.props.highlights.size == 0)
    },
});
